import React from "react";
import { perssonesIcon } from "../../assets/images/icons";
import { resolveImageUrl2 } from "../../constants";
import "./hotelroom.css";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next'; // Import useTranslation

export default function Hotelroom({ rate, detail, realrate, propertyCode }) {
  const navigate = useNavigate(); // Initialize navigation hook
  const { t } = useTranslation(); // Use the useTranslation hook

  const room = detail?.room;
  const roomImage = room?.pictures?.[0];

  return (
    <div className="Hotelroom">
      <div className="top_image_container">
        <img 
          className="top_image" 
          src={resolveImageUrl2(`media/rooms/${roomImage?.filename || ''}`)} 
          alt="hotel room" 
        />
      </div>
      
      <div className="bottom_container">
        <div className="info">
          <img className="icon" src={perssonesIcon} alt="persons" />
          <p className="el">
            {`${room?.max_adults || 0} ${t('hotelroom.adults')}, ${room?.max_children || 0} ${t('hotelroom.children')}`} {/* Translated text */}
          </p>
        </div>
        
        <p className="desc">
          {room?.description || t('hotelroom.noDescription')} {/* Translated text */}
        </p>
        
        <div className="reservation">
          <p className="price">{`${detail?.price_1 || '0'} DZD`}</p>
          <button
            onClick={() =>
              navigate("/hcheckout", { state: { rate: rate, detail: detail, realrate: realrate, propertyCode: propertyCode } })
            }
          >
            <p>{t('hotelroom.reserve')}</p> {/* Translated text */}
          </button>
        </div>
      </div>
    </div>
  );
}